<template lang='pug'>
	#app
		img#dots-top.dots(src='../src/assets/top.svg')
		router-view(v-on:hide='showLogo = false' v-on:show='showLogo = true')
		img#dots-bottom.dots(src='../src/assets/bottom.svg')
		.logo(v-html='require("!html-loader!../src/assets/logo.svg")' :class='{ hide: !showLogo }')
</template>

<script>
export default {
	name: 'Kaffitar',
	data: function () {
		return {
			showLogo: true
		};
	}
};
</script>

<style lang='less'>

@font-face {
  font-family: cheddar;
  src: url('../src/assets/font/CheddarGothicRough-Regular.otf') format('opentype');
  font-weight: 400;
}

@font-face {
  font-family: corpid;
  src: url('../src/assets/font/CorpidC1sCd-RegularItalic.otf') format('opentype');
  font-weight: 400;
  font-style: italic;
}

@font-face {
  font-family: corpid;
  src: url('../src/assets/font/CorpidC1s-BoldItalic.otf') format('opentype');
  font-weight: 600;
  font-style: italic;
}

@font-face {
  font-family: veneer;
  src: url('../src/assets/font/Veneer.ttf') format('truetype');
  font-weight: 400;
}

.noselect {
	-webkit-touch-callout: none;
	-webkit-user-select: none;
	-khtml-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

.logo {
	position: absolute;
	top: 470px;
	transform: translateY(-50%);
	left: 50px;
	width: 80px;
	height: auto;
	transition: .3s;
	opacity: 1;
	@media screen and (max-width: 768px) {
		opacity: 0;
		pointer-events: none;
	}
	&.hide {
		opacity: 0;
	}
}

.hover {
	cursor: pointer;
}

.tk-proxima-nova {
	font-size: 24px;
	&.small {
		font-size: 16px;
	}
}

.cheddar {
	font-family: cheddar;
}

.corpid {
	font-family: corpid;
	font-weight: 400;
	&.italic {
		font-style: italic;
	}
	&.bold {
		font-weight: 600;
	}
}

.veneer {
	font-family: veneer;
}

body, html {
	padding: 0px;
	margin: 0px;
}
#app {
	overflow: hidden;
	position: absolute;
	min-height: 100%;
	width: 100%;
	background-image: url('../src/assets/back.jpg');
	background-repeat: repeat;
	.dots {
		pointer-events: none;
		position: absolute;
		width: 100vw;
		min-height: auto;
		left: 0px;
		object-fit: cover;
		max-height: 150px;
		min-height: 150px;
		transition: .3s;
		@media screen and (max-width: 560px) {
			left: -200px;
			width: calc(100vw + 200px);
		}
		&#dots-top {
			top: 0px;
		}
		&#dots-bottom {
			bottom: 0px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/App.vue